<div class="flex flex-row w-full flex-wrap">
  <div class="flex flex-grow flex-wrap gap-1">
    @for (item of displayAll ? (value ?? []) : (value | take: maxDisplayed); track item) {
      <span
        class="select-pill fluid flex-nowrap"
        >
        <ng-container
          *ngTemplateOutlet="entityTemplate; context: $any({ entity: item })"
        ></ng-container>
        @if (!readonly) {
          <i
            class="fa-regular fa-xmark pointer ml-1"
            (click)="onDelete(item)"
          ></i>
        }
      </span>
    }
    <input
      class="mr-2 w-full"
      [value]="input"
      (input)="onInput(inputComponent.value)"
      [readOnly]="readonly"
      placeholder="{{
        placeholder || '#UI_CORE.COMPONENTS.ENTITY_LIST_INPUT.PLACEHOLDER' | translate
      }}"
      #inputComponent
      />
  </div>
  <div>
    @if (!displayAll && (value?.length ?? 0) > maxDisplayed + 1) {
      <span
        class="soft-link small fluid flex-nowrap"
        (click)="displayAll = true"
        >
        {{
        '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_MORE_PL'
        | translate
        | interpolate: { count: (value?.length ?? 0) - maxDisplayed }
        }}
      </span>
    }
    @if (!displayAll && (value?.length ?? 0) === maxDisplayed + 1) {
      <span
        class="soft-link small fluid flex-nowrap"
        (click)="displayAll = true"
        >
        {{ '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_MORE_SG' | translate }}
      </span>
    }
    @if (displayAll && (value?.length ?? 0) > maxDisplayed) {
      <span
        class="soft-link small fluid flex-nowrap"
        (click)="displayAll = false"
        >
        {{ '#UI_CORE.COMPONENTS.MULTI_SELECT.DISPLAY_LESS' | translate }}
      </span>
    }
  </div>
</div>

@if (strategy.loading()) {
  <i class="fa-regular fa-spinner fa-spin ml-4"></i>
}
@if (strategy.loading() || inputComponent.value.length > 0 || value?.length) {
  <div
    id="closeDialog"
    class="ml-4 pointer"
    (click)="onCancel(); $event.stopPropagation()"
    >
    <i class="fa-regular fa-xmark"></i>
  </div>
}
@if (!strategy.loading()) {
  @if (!readonly) {
    <div
      id="openDialog"
      class="ml-4 pointer order-100"
      (click)="onOpen(); $event.stopPropagation()"
      >
      <i class="fa-regular fa-database"></i>
    </div>
  }
}
